export const FEEDBACK_PREFIX = 'mailto:rcv.desktop.feedback';
export const BLANK_URL = 'about:blank';
